import API from './API';
var PrizeSchemeService = {
    getPrizeScheme: function (id, config) {
        return API.get("/prize_schemes/".concat(id), config);
    },
    getPrizeSchemes: function (config) {
        return API.get('/prize_schemes', config);
    },
    addPrizeScheme: function (data, config) {
        return API.post('/prize_schemes/add', data, config);
    },
    editPrizeScheme: function (data, config) {
        return API.post('/prize_schemes/' + data.id + '/edit', data, config);
    },
    deletePrizeScheme: function (data, config) {
        return API.post('/prize_schemes/' + data.id + '/delete', data, config);
    }
};
export default PrizeSchemeService;
